import { Button } from "antd";
import { FertilizationCerealsMap } from "./map/index";
import { useTranslation } from "react-i18next";
import { DinamicByRegionsOctober } from "./NecessaryvsSecured/index";
import { Percentagebyregion } from "./Percentagebyregion";
import { useGetTerritorialUnitsGetpolygonsListQuery } from "../../../redux/api/handBooksApi/territorialUnitsApi";
import { useGetFertilizerOctoberQuery, useGetFertilizerOctoberAllQuery } from "./api";
import { EntTerritorialUnitsFilter } from "../../../models/filters/territorialUnitsFilter";
import { useState, useCallback } from "react";
import { PreloaderSvg } from "../../preloaderSvg/PreloaderSvg";
import ReportChemicalization from "../../../pages/admin/chemicalization/reportChemicalization/ReportChemicalization";
import { PlusOutlined } from "@ant-design/icons";
import { useReportWinterCerealFertilizerMutation } from "../../../redux/api/chemicalization/winterCerealFertilizer";
import style from "./style.module.css";

export const FertilizationCereals = () => {
    const { t } = useTranslation();
    const [selectedYear, setSelectedYear] = useState<number | null>(null);
    const [selectedRegionId, setSelectedRegionId] = useState<number | "">("");
    const [selectedRegionName, setSelectedRegionName] = useState<string>("");
    const [isLoading, setIsLoading] = useState(false);
    const [getReportWinterCerealFertilizer] = useReportWinterCerealFertilizerMutation();
    const [isLoadingMap, setIsLoadingMap] = useState(false);
    const [showReportModal, setShowReportModal] = useState<boolean>(false);

    const getReport = async (payload: { periodStart: string; periodEnd: string; language: string }): Promise<Blob> => {
        return await getReportWinterCerealFertilizer(payload).unwrap();
    };
    const openReportModal = () => {
        setShowReportModal(true);
    };
    const { data: polygonsData, isLoading: polygonsLoading } = useGetTerritorialUnitsGetpolygonsListQuery(
        new EntTerritorialUnitsFilter({ page: 1, size: 15 })
    );

    const { data: fertilizercropsData, isLoading: isLoadingCropFertilizers } = useGetFertilizerOctoberQuery({
        year: selectedYear ? selectedYear.toString() : undefined,
        territorialUnitRegionId: selectedRegionId
    });

    const { data: fertilizercropsAllData, isLoading: isLoadingCropFertilizersAll } = useGetFertilizerOctoberAllQuery({
        year: selectedYear ? selectedYear.toString() : undefined,
    });

    const handleRegionClick = useCallback((regionId: number, regionName: string) => {
        setSelectedRegionId(regionId);
        setSelectedRegionName(regionName);
    }, []);

    const handleResetRegion = useCallback(() => {
        setSelectedRegionId("");
        setSelectedRegionName("");
    }, []);

    if (isLoading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <PreloaderSvg />
            </div>
        );
    }

    return (
        <div className={style.container}>
            <div className={style.content}>
                <div className={style.title}>
                    <div className={style.title_header}>
                        <h1>{t('Soil composition enrichment for winter cereals (October-December)')}</h1>
                        <Button style={{ marginLeft: '5px' }} type="primary" icon={<img src="../../../report.svg" alt="Plus Icon" style={{ width: '16px', height: '16px' }} />}
                            onClick={() => openReportModal()}>
                            {t('reports.report_by_winter_cereals')}
                        </Button>
                        <ReportChemicalization
                            title={ t('reports.report_by_winter_cereals') }
                            getReport={getReport}
                            show={showReportModal}
                            onHide={() => setShowReportModal(false)}
                        />
                    </div>
                    <div className={style.title_inner}>
                        <img src="../../../homeicon.svg" alt="home" />
                        <p>{t('Home')}</p>
                        <img src="../../../arrowright.svg" alt="arrow" />
                        <p>{t('Mineral fertilizers')}</p>
                        <img src="../../../arrowright.svg" alt="arrow" />
                        <span className={style.namepage}>{t('Soil composition enrichment for winter cereals (October-December)')}</span>
                    </div>
                </div>

                <div className={style.mapcontainer}>
                    <FertilizationCerealsMap
                        latitude={41.5089324}
                        longitude={74.724091}
                        polygonsData={polygonsData}
                        selectedYear={selectedYear}
                        onYearChange={setSelectedYear}
                        isLoadingFertilizers={isLoadingCropFertilizers}
                        isLoadingFertilizersOnMap={isLoadingMap}
                        onRegionClick={handleRegionClick}
                        onResetRegion={handleResetRegion}
                        selectedRegionName={selectedRegionName}
                        fertilizerData={fertilizercropsData}
                    />
                </div>

                <div className={style.charts}>
                    <DinamicByRegionsOctober
                        fertilizercropsAllData={fertilizercropsAllData}
                        selectedYear={selectedYear}
                        onYearChange={setSelectedYear}
                    />
                    {/* <Percentagebyregion/> */}
                </div>
            </div>
        </div>
    );
};